import { render, staticRenderFns } from "./ModalForgotPin.vue?vue&type=template&id=49991a01&"
import script from "./ModalForgotPin.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPin.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgotPin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports